import { defaultRichTextValue } from '@/components/Editor/Editor'
import { Input } from './input'
import { i18n } from '@/plugins/i18n'

const fallbackLanguage = 'eng'
const staticTranslation = {
    nor: {
        textYes: 'Ja',
        textNo: 'Nei',
        textNotRelevant: 'Ikke relevant',
    },
    swe: {
        textYes: 'Ja',
        textNo: 'Nej',
        textNotRelevant: 'Ej tillämpligt',
    },
    eng: {
        textYes: 'Yes',
        textNo: 'No',
        textNotRelevant: 'Not relevant',
    },
    pol: {
        textYes: 'Tak',
        textNo: 'Nie',
        textNotRelevant: 'Nieistotne',
    },
    dan: {
        textYes: 'Ja',
        textNo: 'Nej',
        textNotRelevant: 'Ikke relevant',
    },
} as const

type StaticLanguageKeys = keyof typeof staticTranslation

export class YesNoInput extends Input {
    constructor(language: string, inputData?: Partial<Input>) {
        super(language, inputData)
        this.kind = 'radioGroup'
        this.renderHint = 'yesNo'
        this.name = `form_fe['revision.heading_yesNoInputItem']`
        this.icon = 'fa fa-check-square'
        this.supportScoring = true

        if (!inputData) {
            this.weight = 1
            this.addItem({
                text: defaultRichTextValue(
                    i18n.t(`form_fe['revision.inputOption.text_yes']`).toString()
                ),
            })
            this.addItem({
                text: defaultRichTextValue(
                    i18n.t(`form_fe['revision.inputOption.text_no']`).toString()
                ),
            })
        }
    }

    private getStaticTranslation(
        key: keyof (typeof staticTranslation)[StaticLanguageKeys],
        language: string
    ) {
        return staticTranslation[language]?.[key] || staticTranslation[fallbackLanguage][key]
    }

    setItemDefaultText(language: string) {
        if (!Array.isArray(this.items)) return

        const [yesOption, noOption, notRelevantOption] = this.items
        if (!yesOption.text[language]) {
            yesOption.text[language] = defaultRichTextValue(
                this.getStaticTranslation('textYes', language)
            )
        }
        if (!noOption.text[language]) {
            noOption.text[language] = defaultRichTextValue(
                this.getStaticTranslation('textNo', language)
            )
        }
        if (notRelevantOption && !notRelevantOption.text[language]) {
            notRelevantOption.text[language] = defaultRichTextValue(
                this.getStaticTranslation('textNotRelevant', language)
            )
        }
    }
}
